/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface ResolvedExcludedProfileMatch {
  input_url: string;
  normalized_url?: string | null;
  matched?: boolean;
  candidate_id?: string | null;
  full_name?: string | null;
}
